import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { getQueryStringValue } from '~/modules/analytics/gtmEventTypes/gtmEventTypeHelper';
import { logger } from '../../utilities/logger';
import { GA4ContentClickEvent, GTMBaseEvent, GtmAnalyticsEvent, GtmEventType } from './gtmEventType';

export type GtmLinkClickEvent = {
    destinationType: string;
    clickUrl?: string;
    ctaClick: boolean;
    clickText?: string;
    elementType: string;
    itemTitle?: string;
} & GtmAnalyticsEvent;

type GTMContentEvent = {
    content?: {
        title: string;
    };
} & GTMBaseEvent;

type GTMTTabEvent = {
    tab?: {
        title: string;
    };
} & GTMBaseEvent;

type GTMLinkEvent = {
    link: {
        callToAction: {
            url?: string;
            label?: string;
        };
    };
} & GTMBaseEvent;

type GTMTiles = {
    title?: string;
    tiles?: {
        title?: string;
    };
} & GTMBaseEvent;

type GTMListing = {
    listing?: {
        title?: string;
    };
} & GTMBaseEvent;

export type GA4MoreInClick = {
    title: string;
    tiles: {
        title: string;
    };
} & GTMLinkEvent;

type GTMLinkClickEventType = GTMLinkEvent & GTMContentEvent & GTMTTabEvent & GTMTiles & GTMListing;

export class GtmLinkClickType extends GtmEventType {
    canHandle(event: GTMBaseEvent): boolean {
        return (
            event.topic === AnalyticsEventTopic.ANALYTICS_CLICK &&
            event.elementType === 'link' &&
            ((!event.listing && !event.content && !event.tab && !event.oafId) || !!event.listing || !!event.content)
        );
    }

    getBody(event: GTMBaseEvent): GA4ContentClickEvent {
        return this.getGa4Body(event as GA4MoreInClick);
    }

    getGa4Body(event: GA4MoreInClick): GA4ContentClickEvent {
        // TODO: This only applies to More In <Category> on Explore
        return {
            event: 'custEv_contentClick',
            click_text: event.link.callToAction.label || '',
            click_url: event.link.callToAction.url || '',
            element_title: this.getItemTitle(event) || '',
            element_type: 'link',
            content_category: event.tiles?.title || '',
            internal_driver: getQueryStringValue(event.link.callToAction?.url || '', 'd'),
        };
    }

    getItemTitle(event: GTMLinkClickEventType): string | undefined {
        if (event.content) {
            return event.content.title;
        }
        if (event.listing) {
            return event.listing.title;
        }
        if (event.tiles?.title) {
            return event.tiles.title;
        }
        return event.link.callToAction.label;
    }

    isValidG4Event(event: GA4ContentClickEvent): boolean {
        return !!event.event && !!event.click_text && !!event.element_title && !!event.click_url;
    }

    isValidEvent(event: GtmLinkClickEvent | GA4ContentClickEvent): boolean {
        const valid = this.isValidG4Event(event as GA4ContentClickEvent);
        if (!valid) {
            logger.error(`GTM event missing required fields:  ${JSON.stringify(event)}`);
        }
        return valid;
    }
}
